let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fpqaT")).then(() => parcelRequire('8e3SW'));